import React, { useEffect, useRef } from 'react';
import { Title, TitleContainer, Message } from './SeeYaSoon.styles';
import FormContainer from '../../utils/FormContainer/FormContainer';
import { useSelector } from 'react-redux';
import { selectInvitationGuestMembers, selectRSVPInfo } from '../../../store/slice/rsvp/slice';
import { confetti } from '../../../utils/confetti';
import { useSearchParams } from 'react-router-dom';

const SeeYaSoon = () => {
  const rsvp = useSelector(selectRSVPInfo);
  const { data } = useSelector(selectInvitationGuestMembers);
  let [searchParams] = useSearchParams();

  const guestAnswer = searchParams.get('answer');

  useEffect(() => {
    if (data.length && guestAnswer === 'ACCEPTED') {
      confetti();
    }
    // else {
    //   pop(0, 0, 'emoji');
    // }
  }, [data.length, guestAnswer]);

  return (
    <>
      {guestAnswer && guestAnswer === 'DECLINED' && (
        <div class="snowflakes">
          {/* <div class="snowflake">😢</div>
          <div class="snowflake">😢</div>
          <div class="snowflake">😢</div>
          <div class="snowflake">😢</div>
          <div class="snowflake">😢</div>
          <div class="snowflake">🙁</div>
          <div class="snowflake">🙁</div>
          <div class="snowflake">🙁</div>
          <div class="snowflake">🙁</div>
          <div class="snowflake">🙁</div> */}
        </div>
      )}

      <FormContainer gap>
        <TitleContainer>
          {guestAnswer === 'DECLINED' ? (
            <>
              {/* <div id="bodySmiley" className="bodySmiley"></div> */}
              <Message>{`Thank you for your reply,`}</Message>
              <Message>{`your presence will be missed!`}</Message>
            </>
          ) : (
            <>
              <Message>{`Thank you for your reply, we cannot wait to celebrate with our friends and family.`}</Message>
              <Message>{`See you there!`}</Message>
            </>
          )}
        </TitleContainer>
        <Title>{`${rsvp.brideName} & ${rsvp.groomName}!`}</Title>
      </FormContainer>
    </>
  );
};

export default SeeYaSoon;
